import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const api = pythonVmInstance;

// Sales Order APIs
export const getStats = () => api.get("/api/stats");

export const getSalesOrders = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.barcode_status) params.append("barcode_status", filters.barcode_status);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);

	return api.get(`/api/sales-orders?${params.toString()}`);
};

export const getSalesOrderItems = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.barcode_status) params.append("barcode_status", filters.barcode_status);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);

	return api.get(`/api/sales-orders/items?${params.toString()}`);
};

export const downloadSalesOrderItemsExcel = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.barcode_status) params.append("barcode_status", filters.barcode_status);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);

	return api.get(`/api/sales-orders/items/download?${params.toString()}`, {
		responseType: 'blob'
	});
};

export const downloadSalesOrderItemsCsv = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.barcode_status) params.append("barcode_status", filters.barcode_status);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);

	return api.get(`/api/sales-orders/items/download-csv?${params.toString()}`, {
		responseType: 'blob'
	});
};

export const getSalesOrderDetail = (soNo) => api.get(`/api/sales-orders/${soNo}`);

export const getCourierTracking = (awb, courierName) => api.get(`/api/courier-tracking/${awb}?courier=${courierName}`);

export const generatePodUrl = (podGcsUri) => api.post("/api/pod/generate-url", { podGcsUri });

export const getTatConfig = () => api.get("/api/config/tat");

export default api;
